module.exports = __webpack_public_path__ + "static/media/bus.e69e7a84.svg";